import React, { useState, useEffect } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Show splash for 2 seconds, then fade out
    const showTimer = setTimeout(() => {
      setIsFading(true);
    }, 2000);

    // Complete fade out after animation
    const fadeTimer = setTimeout(() => {
      setIsVisible(false);
      onComplete();
    }, 2500);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(fadeTimer);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-500  bg-teal-300 ${
        isFading ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="text-center text-black">
        {/* App Icon/Logo */}
        <div className="mb-8">
          <div className="  rounded-3xl flex items-center justify-center">
            <img 
              src="/arcade/games/riddl/icons/riddl_icon.png" 
              alt="Riddl App Icon" 
              className="w-20 h-20 object-contain"
            />
          </div>
        </div>
        
        {/* App Name */}
        <h1 className="text-4xl font-bold mb-2 tracking-wide">
          Riddl
        </h1>
        
        {/* Tagline */}
        <p className="text-lg opacity-90 font-medium">
          Daily Riddle Challenges
        </p>
        
        {/* Loading Animation */}
        <div className="mt-8 flex justify-center">
          <div className="flex space-x-2">
            <div className="w-2 h-2 bg-black/60 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-black/60 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-black/60 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
